import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';
import { ProductCosting } from 'src/app/model/Production/Costing/product-costing';
import { ProductionPlanning } from 'src/app/model/Production/ProductionPlanning/production-planning';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ProductionService {
  private handleError: HandleError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('ProductionService');
  }

  insertProductionPlanning(url: string, data: ProductionPlanning) {
    return this.http.post(url, data);
  }
  getProductionPlanningByDate(url: string, date: string) {
    return this.http.get(url + "/" + date);
  }
  deleteProductionPlanningById(url: string, id: number) {
    return this.http.get(url + "/" + id);
  }
  generateProductionPlanningByDate(url: string, date: string) {
    return this.http.get(url + "/" + date);
  }


  getAllUnitNames(url: string) {
    return this.http.get(url);
  }

  getInitialData(url: string, locationId: number) {
    return this.http.get<any>(url + "/" + locationId);
  }

  getProductSearch(url: string, word: string) {
    return this.http.get<any>(url + '/' + word)
      .pipe(
        catchError(this.handleError('getProductSearch()', []))
      );
  }

  //Production Costing

  getProductByProductCode(url: string, productCode: number) {
    return this.http.get(url + "/" + productCode)
      .pipe(
        catchError(this.handleError('getProductByProductCode()', []))
      );
  }

  getProducts(url: string, invCode: number, productName: string) {
    return this.http.get(url + "/" + invCode + "/" + productName)
      .pipe(
        catchError(this.handleError('getProducts()', []))
      );
  }

  insertProductCosting(url: string, productCosting: ProductCosting) {
    return this.http.post(url, productCosting);
  }

  viewProductCosting(url: string, requestView: RequestView) {
    return this.http.post(url, requestView);
  }

  cancelProductCosting(url: string, costingNo: string) {
    return this.http.get(url + "/" + costingNo);
  }

  getProductCostingByProductCode(url: string, productCode: number) {
    return this.http.get(url + "/" + productCode);
  }

}
